import { Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { InterviewStatus } from "@src/appV2/Shifts/MyShifts/api/useFetchPaginatedInterviews";
import { useMemo } from "react";

import { type PlacementDetail } from "../api/useGetPlacement";
import { getFormattedInterviewDate } from "../utils";

interface PlacementApplicationMessageProps {
  interviews: PlacementDetail["interviews"];
  workplaceName: string;
  workerTimezone: string;
}

export function PlacementApplicationMessage(props: PlacementApplicationMessageProps) {
  const { interviews, workplaceName, workerTimezone } = props;

  const interviewInfo = useMemo(() => {
    const bookedInterview = interviews.find(
      (interview) => interview.attributes.status === InterviewStatus.BOOKED
    );

    if (isDefined(bookedInterview)) {
      return `Your interview is booked for ${getFormattedInterviewDate(
        bookedInterview,
        workerTimezone
      )}.`;
    }

    const attendedInterview = interviews.find(
      (interview) => interview.attributes.status === InterviewStatus.ATTENDANCE_CONFIRMED
    );
    if (isDefined(attendedInterview)) {
      return `Your interview was held on ${getFormattedInterviewDate(
        attendedInterview,
        workerTimezone
      )}.`;
    }

    return `If your application is approved, you&apos;ll receive an email with an interview invite from the facility!`;
  }, [interviews, workerTimezone]);

  return (
    <Text variant="caption">
      You&apos;ve successfully applied for this job at {workplaceName}. {interviewInfo}
    </Text>
  );
}
